<script>
import CoverSheetManager from '@/components/document-validation/coverSheet/CoverSheetManager.vue'
export default {
  components: {CoverSheetManager},
  props: {
    selected: {type: Array},
    order: {type: Object}
  },
  data: () => ({
    isCoverSheetManagerDialogOpen: false,
    enumRules: [
      271, // PageCountValidationFailed
      272, // LargeLetterPageCountValidationFailed
      273, // FoldTypeValidationFailed
      283, // DuplicatesExists
      290, // PageSizeValidationFailed
      291, // PageOrientationValidationFailed
      292, // PzuSheetCountValidationFailed
      501, // UserHasNoPermission
      520, // PdfFileEncrypted
      601, // WhiteLineColorModeNotParseable
      602, // WhiteLinePrintModeNotParseable
      603, // WhiteLineFoldTypeNotParseable
      604, // WhiteLinePaperTypeNotParseable
      605, // WhiteLineCustomMergeValueNotParseable
      606, // WhiteLineCustomMergeIndexNotParseable
      607, // WhiteLineCostCenterNotParseable
      608, // WhiteLineMandantNotParseable
      609, // WhiteLineUnknownKeyNameInclude
      610, // WhiteLineMultipleZVVInclude
      691, // WhiteLineSerialSequenceNotParseable
      699, // WhiteLineNotParsable
    ]
  }),
  methods: {
    addCoverSheet() {
      return this.isCoverSheetManagerDialogOpen = true
    },
    handleCoverSheetAppending(document) {
      this.$emit('added-coversheet', document)
    },
    handleCoverSheetFinalizing(documents) {
      this.$emit('finalized-coversheet', documents)
    },
    hasTheAbilityToAddCoverSheet() {
      if (this.selected.length > 0) {
        if (this.selected.every(item => item.validationStatus === 10)) {
          return true;
        } else {
          return this.selected.some((item) => {
            // eslint-disable-next-line no-prototype-builtins
            if (item.hasOwnProperty('validationStatus') && item.hasOwnProperty('validationCodes')) {
              const hasValidCode = item.validationCodes.some((code) => {
                const isValid = this.enumRules.includes(code);
                return !isValid;
              });
              return hasValidCode;
            }
            return false;
          });
        }
      }
      return false;
    },
    handleCloseDialog() {
      this.isCoverSheetManagerDialogOpen = false
      this.$emit('clear-selection')
    },
    handleClearSelection() {
      this.$emit('clear-selection')
    }
  }
}
</script>
<template>
  <div class="mx-2">
    <CoverSheetManager
      :is-cover-sheet-manager-dialog-open="isCoverSheetManagerDialogOpen"
      :selected="selected"
      :order="order"
      @close-coversheet-manager="handleCloseDialog"
      @clear-selection="handleClearSelection"
      @added-coversheet-to-document="handleCoverSheetAppending"
      @finalized-coversheet="handleCoverSheetFinalizing"
    ></CoverSheetManager>
    <v-tooltip content-class="dark_tip" top>
      <template #activator="{ on }">
        <v-btn
          id="upload_validation_add_coversheet_to_selected_documents"
          :disabled="!hasTheAbilityToAddCoverSheet()"
          :loading="false"
          icon
          outlined
          color="blue"
          v-on="on"
          @click="addCoverSheet()">
          <v-icon color="blue">mdi-file-document-outline</v-icon>
        </v-btn>
      </template>
      <span>{{ $t('component.documentValidation.addCoverSheetButton.tooltip.attachment.icon') }}</span>
    </v-tooltip>
  </div>
</template>
